module.exports = __webpack_public_path__ + "img/Frame-98.76548052.svg";